import { render, staticRenderFns } from "./ContactUpdate.vue?vue&type=template&id=1368f756"
import script from "./ContactUpdate.vue?vue&type=script&lang=js"
export * from "./ContactUpdate.vue?vue&type=script&lang=js"
import style0 from "./ContactUpdate.vue?vue&type=style&index=0&id=1368f756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports